'use client';

import React from 'react';
import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';
import Image from 'next/image';
import { signOut, useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { cn } from '@/helpers/common';
import HeaderDropdownDC from './HeaderDropdownDC';

const desktopLinkCn =
  'text-sm font-bold text-dc-cod-gray no-underline default-transition decoration-dc-vermilion decoration-2 underline-offset-[6px] hover:underline';

const HeaderDC = () => {
  const pathname = usePathname();
  const { data: value } = useSession();
  const session = value;

  return (
    <header className="flex md:px-10 max-md:px-4 min-h-20 border-b border-dc-gallery bg-white">
      <div className="max-w-260 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4">
        <Link href={ROUTES.home} aria-label="David Careers home">
          <Image
            width="113"
            height="52"
            src="https://assets.davidcareers.com/davidcareers/cont_regular/logo_hr.png"
            alt="David Careers"
            unoptimized
            priority
          />
        </Link>
        <nav aria-label="Main" className="md:flex max-md:hidden items-center gap-6">
          <a
            aria-current={pathname === ROUTES.about ? 'page' : undefined}
            className={cn(desktopLinkCn, { underline: pathname === ROUTES.about })}
            href={ROUTES.about}
          >
            ABOUT
          </a>
          <a
            aria-current={pathname === ROUTES.jobs ? 'page' : undefined}
            className={cn(desktopLinkCn, { underline: pathname === ROUTES.jobs })}
            href={ROUTES.jobs}
          >
            FIND JOBS
          </a>
          <a
            aria-current={pathname === ROUTES.partners ? 'page' : undefined}
            className={cn(desktopLinkCn, { underline: pathname === ROUTES.partners })}
            href={ROUTES.partners}
          >
            PARTNERS
          </a>
          {session ? (
            <>
              <a
                aria-current={pathname === ROUTES.profile ? 'page' : undefined}
                className={cn(desktopLinkCn, {
                  underline: pathname === ROUTES.profile || pathname === ROUTES.history,
                })}
                href={ROUTES.profile}
              >
                CAREER PROFILE
              </a>
              <button
                className="px-3 py-2 text-sm font-bold text-dc-vermilion no-underline default-transition border border-dc-vermilion rounded-lg bg-white hover:bg-dc-vermilion12"
                onClick={() => signOut()}
              >
                SIGN OUT
              </button>
            </>
          ) : (
            <a
              className={cn(desktopLinkCn)}
              href={pathname === ROUTES.signin ? ROUTES.signup : ROUTES.signin}
            >
              {pathname === ROUTES.signin ? 'SIGN UP' : 'SIGN IN'}
            </a>
          )}
        </nav>
        <div className="md:hidden max-md:block">
          <HeaderDropdownDC session={session} isSighInPath={pathname === ROUTES.signin} />
        </div>
      </div>
    </header>
  );
};

export default HeaderDC;
